import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listarCajas } from "../../servicios/cajasApi";
import { extraerCajas } from "../../servicios/cajas";
import { useStoreHome } from "../Home/useStoreHome";
import { useStoreCajas } from "./useStoreCajas";

export default function CajaAperturaModal({ abierto, onCerrar }) {
  const { t } = useTranslation();
  const empresaId = useStoreHome((state) => state.EmpresaId);
  const [cajas, setCajas] = useState([]);
  const [cajaId, setCajaId] = useState("");
  const [saldoInicial, setSaldoInicial] = useState("0");
  const [observacion, setObservacion] = useState("");
  const [cargandoLista, setCargandoLista] = useState(false);
  const cargando = useStoreCajas((state) => state.cargando);
  const error = useStoreCajas((state) => state.error);

  useEffect(() => {
    if (!abierto) return;
    let vigente = true;
    setCargandoLista(true);
    listarCajas({ EmpresaId: empresaId, activo: true })
      .then((respuesta) => {
        if (!vigente) return;
        const errorLista = respuesta.error || respuesta.data?.error || respuesta.data?.Error || "";
        if (errorLista) useStoreCajas.setState({ error: errorLista });
        const lista = extraerCajas(respuesta);
        setCajas(lista);
        if (lista.length === 1) setCajaId(String(lista[0].id));
      })
      .finally(() => vigente && setCargandoLista(false));
    return () => { vigente = false; };
  }, [abierto, empresaId]);

  if (!abierto) return null;

  const abrir = async (evento) => {
    evento.preventDefault();
    if (!cajaId || Number(saldoInicial) < 0) return;
    const ok = await useStoreCajas.getState().abrirCaja({ cajaId, saldoInicial, observacion });
    if (ok) onCerrar?.();
  };

  return (
    <div className="cajas-modal-fondo" role="presentation" onMouseDown={(evento) => evento.target === evento.currentTarget && onCerrar?.()}>
      <form className="cajas-modal" onSubmit={abrir}>
        <header>
          <div className="cajas-modal-titulo">
            <span><i className="pi pi-wallet" /></span>
            <div><small>{t("cash.newSession")}</small><h2>{t("cash.openCashRegister")}</h2></div>
          </div>
          {onCerrar && <button type="button" className="cajas-modal-cerrar" aria-label={t("common.close")} onClick={onCerrar} disabled={cargando}><i className="pi pi-times" /></button>}
        </header>
        <div className="cajas-modal-cuerpo">
          <p className="cajas-modal-intro">{t("cash.selectCashRegisterIntro")}</p>
          <label><span>{t("cash.cashRegister")}</span><select required value={cajaId} onChange={(evento) => setCajaId(evento.target.value)} disabled={cargando || cargandoLista}><option value="">{cargandoLista ? t("cash.loadingCashRegisters") : t("cash.selectCashRegister")}</option>{cajas.map((caja) => <option key={caja.id} value={caja.id}>{caja.codigo} — {caja.descripcion}</option>)}</select></label>
          {!cargandoLista && !cajas.length && <div className="cajas-aviso"><i className="pi pi-info-circle" /><span>{t("cash.noActiveCashRegisters")}</span></div>}
          <label><span>{t("cash.openingBalance")}</span><div className="cajas-input-moneda"><b>$</b><input required type="number" min="0" step="0.01" value={saldoInicial} onChange={(evento) => setSaldoInicial(evento.target.value)} /></div></label>
          <label><span>{t("cash.observation")} <em>{t("common.optional")}</em></span><textarea value={observacion} onChange={(evento) => setObservacion(evento.target.value)} maxLength="250" placeholder={t("cash.observationPlaceholder")} /></label>
          {error && <div className="cajas-error" role="alert"><i className="pi pi-exclamation-circle" /><span>{error}</span></div>}
        </div>
        <footer>{onCerrar && <button type="button" className="secundario" onClick={onCerrar} disabled={cargando}>{t("common.cancel")}</button>}<button type="submit" className="primario" disabled={cargando || cargandoLista || !cajaId}><i className={`pi ${cargando ? "pi-spin pi-spinner" : "pi-lock-open"}`} /> {cargando ? t("cash.opening") : t("cash.openCashRegister")}</button></footer>
      </form>
    </div>
  );
}
